export const rechargeAmountList = [
  50, 100, 200, 300, 500, 1000, 2000, 3000, 5000
];
